import { paymentDetailsDto } from "@reactive-resume/dto";
import { create } from "zustand";

export type DialogType =
  | "DOWNLOAD"
  | "CREATE"
  | "RESUME_CREATION"
  | "PDF_DOWNLOAD"
  | "AI_TAILORING"
  | "ATS_SCORING"
  | "RESUME_PARSING"
  | "INTERVIEW_PRACTICE"
  | "SPOTLIGHT_INTRO"
  | "SUBSCRIPTION_LAPSED"
  // First Round plan dialog reasons
  | "PLANS"
  | "CHOOSE_PLAN"
  | "DEMO_USED_UP"
  | "PASS_ENDED";

/** A plan or code picked before the dialog opened, e.g. on firstround.com.au. */
export type PlanIntent = { plan?: "free" | "starter" | "active"; code?: string };

export type UpgradeInfo = {
  featureKey?: string;
  featureName?: string;
  currentUsage?: number;
  limit?: number | null;
  tier?: string;
  availablePacks?: Array<any>;
  redirectTo?: string;
};

export type paymentState = {
  payment: paymentDetailsDto;
  showPaymentDialog: boolean;
  dialogType: DialogType;
  resumeCount: number;
  upgradeInfo?: UpgradeInfo;
  planIntent?: PlanIntent;
  /** The plan picker: no way to close it until a plan is chosen (A18). */
  mandatory: boolean;
  updatePayment: (data: paymentDetailsDto) => void;
  /** Opens the First Round plan dialog. */
  openPlans: (options?: {
    reason?: DialogType;
    info?: UpgradeInfo;
    intent?: PlanIntent;
    mandatory?: boolean;
  }) => void;
  updatePaymentDialog: (data: boolean, type: DialogType, info?: UpgradeInfo) => void;
  updateResumeCount: (count: number) => void;
  resetPaymentDialog: () => void;
};

export const usePaymentStore = create<paymentState>()((set) => ({
  //--- progess tabs
  payment: {
    isPaid: false,
    downloadCount: 0,
  },
  showPaymentDialog: false,
  dialogType: "CREATE",
  resumeCount: 0,
  upgradeInfo: undefined,
  planIntent: undefined,
  mandatory: false,
  openPlans: (options = {}) =>
    set((state) => ({
      showPaymentDialog: true,
      dialogType: options.reason ?? "PLANS",
      upgradeInfo: options.info,
      planIntent: options.intent ?? state.planIntent,
      mandatory: Boolean(options.mandatory) || (state.showPaymentDialog && state.mandatory),
    })),
  updatePayment: (data) =>
    set({
      payment: data,
    }),
  updatePaymentDialog: (open, type, info) =>
    set((state) => ({
      showPaymentDialog: open,
      dialogType: type ?? state.dialogType,
      upgradeInfo: open ? info : undefined,
      // A limit hit while the picker is up mustn't make it closable.
      mandatory: open ? state.mandatory : false,
      planIntent: open ? state.planIntent : undefined,
    })),
  updateResumeCount: (count) =>
    set({
      resumeCount: count,
    }),
  resetPaymentDialog: () =>
    set({
      showPaymentDialog: false,
      upgradeInfo: undefined,
      planIntent: undefined,
      mandatory: false,
    }),
}));
